// trims string without cutting last word
export const trimString = (str: string, maxLength: number = 30): string => {
  if (str.length <= maxLength) return str;

  let trimmedStr = str.slice(0, maxLength);
  const lastSpaceIndex = trimmedStr.lastIndexOf(' ');

  if (lastSpaceIndex > 0) {
    trimmedStr = trimmedStr.slice(0, lastSpaceIndex);
  }

  return trimmedStr + '...';
};
